import PropTypes from 'prop-types';
import React from 'react';
import AnswerButtonContainer from '../AnswerButton/AnswerButtonContainer';
import LetterGenerator from '../../utils/letterGeneratorUtil';
import { TRC_ANSWER_TYPES, TRC_QUESTION_TYPES } from '../../../constants/measure';

export default class OneTwoAnswerQuestionView extends React.Component {
    constructor(props) {
        super(props);
        this.lettersArray = LetterGenerator(this.props.possibleResponses.length);
    }

    onSelectedAnswer(responseIndex, questionType, maxPossibleResponses) {
        return () => {
            this.props.onAnswerClick(responseIndex, questionType, maxPossibleResponses);
        };
    }

    getNumberOfAnswers() {
        return (this.props.maxPossibleResponses === 2)
            ? `${TRC_ANSWER_TYPES.TWO_ANSWERS} answers`
            : `${TRC_ANSWER_TYPES.ONE_ANSWER} answer`;
    }

    getIsSelected(index) {
        if (this.props.questionType === TRC_QUESTION_TYPES.MULTIPLE_CORRECT_ANSWERS) {
            return this.props.selectedMultiChoiceIndexes.includes(index);
        }
        return index === this.props.selectedIndex;
    }

    getAnswerOption(answer, index, letter) {
        return (
            <AnswerButtonContainer
                text={answer.text}
                key={answer.id}
                index={index}
                isSelected={this.getIsSelected(index)}
                onAnswerClick={this.onSelectedAnswer(
                    index,
                    this.props.questionType,
                    this.props.maxPossibleResponses,
                )}
                letter={letter}
                isEnabled={this.props.isEnabled}
            />
        );
    }

    getAnswers() {
        return (
            <div className="vertical-answer-buttons">
                {
                    this.props.possibleResponses.map((response, index) => this.getAnswerOption(response, index, this.lettersArray[index]), this)
                }
            </div>
        );
    }

    render() {
        return (
            <div>
                <div className="comprehension-question">
                    <div className={`${this.props.measure}-header`}>
                        <div className="header-text">
                            {this.props.stimulus.text}
                        </div>
                    </div>
                </div>
                <div className="comprehension-answers">
                    <p>
                        {`Choose ${this.getNumberOfAnswers()}.`}
                    </p>
                    {this.getAnswers()}
                </div>
            </div>
        );
    }
}

OneTwoAnswerQuestionView.propTypes = {
    measure: PropTypes.string,
    stimulus: PropTypes.object,
    possibleResponses: PropTypes.array,
    questionType: PropTypes.oneOf([
        TRC_QUESTION_TYPES.MULTI_CHOICE,
        TRC_QUESTION_TYPES.MULTIPLE_CORRECT_ANSWERS,
    ]),
    selectedIndex: PropTypes.number,
    maxPossibleResponses: PropTypes.number,
    selectedMultiChoiceIndexes: PropTypes.array,
    onAnswerClick: PropTypes.func,
    isEnabled: PropTypes.bool.isRequired,
};

OneTwoAnswerQuestionView.defaultProps = {
    measure: '',
    stimulus: {},
    possibleResponses: [],
    selectedIndex: undefined,
    questionType: TRC_QUESTION_TYPES.MULTI_CHOICE,
    maxPossibleResponses: undefined,
    selectedMultiChoiceIndexes: [],
    onAnswerClick: () => {},
};
